import { render, staticRenderFns } from "./borrowing-by-project.vue?vue&type=template&id=3d0c96ea&"
import script from "./borrowing-by-project.vue?vue&type=script&lang=js&"
export * from "./borrowing-by-project.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports